export enum ECallbackPlace {
  HeadBlock = 'headblock',
  BlockStickyTop = 'blockStickytop',
}

export interface ICallbackParams {
  agentPhone: string;
  callRightNow: boolean;
  customerPhone: string;
  time: string;
}
